export default __webpack_public_path__ + "static/media/signup-1.19d23775.jpg";